import { Component, ViewChild } from '@angular/core';
import { iBisViewComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';

@Component({
    selector: 'app-files',
    templateUrl: './files.component.html'
})
export class FilesComponent extends iBisViewComponent {

    @ViewChild('filesGrid') declare grid: DxDataGridComponent;

    constructor(public proxy: ProxyService) {
        super(null, proxy.lg, proxy.iui, proxy.activatedRoute);
        this.key = '[MDS]Files';
    }
}
